import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useCallback, useMemo, useState } from 'react';
import { useIoContext, useStore } from '~/contexts';
import { selectors } from '~/store/state-selectors';
import { makeSectionStorage } from './useSectionPreferences.utils';
export const useSectionPreferences = ()=>{
    var _useStore, _useStore1, _collapsedThisVisit_visitKey, _hiddenThisVisit_visitKey;
    const { localStorage } = useIoContext();
    const userId = (_useStore = useStore(selectors.user.id)) !== null && _useStore !== void 0 ? _useStore : '';
    const businessId = (_useStore1 = useStore(selectors.user.businessId)) !== null && _useStore1 !== void 0 ? _useStore1 : '';
    const storage = useMemo(()=>makeSectionStorage(localStorage, userId, businessId), [
        userId,
        businessId
    ]);
    const visitKey = "".concat(userId, ":").concat(businessId);
    const [collapsedThisVisit, setCollapsedThisVisit] = useState({});
    const [hiddenThisVisit, setHiddenThisVisit] = useState({});
    const isCollapsed = (_collapsedThisVisit_visitKey = collapsedThisVisit[visitKey]) !== null && _collapsedThisVisit_visitKey !== void 0 ? _collapsedThisVisit_visitKey : storage.isCollapsed();
    const isHiddenWhileDone = (_hiddenThisVisit_visitKey = hiddenThisVisit[visitKey]) !== null && _hiddenThisVisit_visitKey !== void 0 ? _hiddenThisVisit_visitKey : storage.isHiddenWhileDone();
    const releaseHide = useCallback(()=>{
        if (!isHiddenWhileDone) {
            return;
        }
        storage.releaseHide();
        setHiddenThisVisit((current)=>_object_spread_props(_object_spread({}, current), {
                [visitKey]: false
            }));
    }, [
        storage,
        visitKey,
        isHiddenWhileDone
    ]);
    function toggleCollapsed() {
        const collapsed = !isCollapsed;
        setCollapsedThisVisit((current)=>_object_spread_props(_object_spread({}, current), {
                [visitKey]: collapsed
            }));
        storage.setCollapsed(collapsed);
    }
    function hideWhileDone() {
        storage.hideWhileDone();
        setHiddenThisVisit((current)=>_object_spread_props(_object_spread({}, current), {
                [visitKey]: true
            }));
    }
    return {
        isCollapsed,
        toggleCollapsed,
        isHiddenWhileDone,
        hideWhileDone,
        releaseHide
    };
};
